<template>
  <transition name="fade">
    <div
      class="w-screen fixed h-screen"
      v-if="active"
      style="top:0;left:0;background-color : rgba(0,0,0,.4);"
      :style="{zIndex : zIndex}"
    >
      <div class="flex justify-center items-center h-full w-full p-5" @click.self="closeModal">
        <div
          class="shadow-lg d-theme-dark-bg relative  rounded-lg"
          :class="[classModal || 'w-full  sm:w-2/3 md:w-1/3']"
        >
          <vs-button
            @click="closeModal"
            v-if="!disableClose"
            size="small"
            class="btn-modal-close shadow transition-shadow"
            color="d-theme-dark-bg"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
          ></vs-button>
          <div class="vs-card--header">
            <slot name="header"></slot>
          </div>
          <div class="card-body">
            <slot></slot>
          </div>
          <div class="card-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "modal",
  data() {
    return {};
  },
  props: {
    active: {
      type: Boolean,
      required: true,
      default: false
    },
    classModal: {
      type: String,
      required: false,
      default: ""
    },
    title: {
      type: String,
      required: false,
      default: ""
    },
    disableClose : {
      type : Boolean,
      required : false,
      default : false
    },
    zIndex : {
      type : String,
      required : false,
      default : '100001'
    }
  },
  methods: {
    closeModal() {
      if(!this.disableClose){
        
        this.$emit("toggleActive", false);
      }
      
    }
  },
  watch : {
    active : function(val){
      if(val){
        document.body.classList.add('ez-modal-open');
      }else{
        document.body.classList.remove('ez-modal-open')
      }
    }
  },
  computed: {}
};
</script>
<style lang="css">
.ez-modal-open{
  height: 100vh;
  overflow-y: hidden;
}
.btn-modal-close {
  position: absolute;
  right: -5px;
  top: -5px;
  color: gray;
}
.btn-close:hover {
  top: -3px;
  right: -3px;
  box-shadow: none !important;
}

.card-body {
  max-height: 70vh;
  overflow-x: auto;
}

.footer {
  position: fixed;
  bottom: 0px;
}

.fadein {
  animation: fadein 1s;
}

.fadeout {
  animation: fadeout 1s;
}

@keyframes fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    display: none;
  }
}
</style>